export default {
  UPDATE_INSIDE_IFRAME: (state, value) => {
    state.insideIframe = value;
  },
};
